const LoadingSpinner = () => {
  return <span className="loading loading-bars loading-lg"></span>;
};

export default LoadingSpinner;
